const firebaseConfig = {
  apiKey: "AIzaSyCQ16qOmwP-cqap9Zx7Cgr-4MmWYGBywq4",
  authDomain: "dog-react.firebaseapp.com",
  databaseURL: "https://dog-react.firebaseio.com",
  projectId: "dog-react",
  storageBucket: "dog-react.appspot.com",
  messagingSenderId: "679021748202",
  appId: "1:679021748202:web:311fdf9837136557"
};

export default firebaseConfig;
